import React, { FC, useState, useContext } from 'react';
import {
  Col,
  BrandRow,
  BrandDetails,
  Icon,
  Row,
  Radio,
  LabelWrap,
  Header,
} from './BrandItem.styles';
import { Span } from '../../../../../shared/typefaces/Typefaces.styles';
import { Edit, Tick, Arrow, Dot } from '../../../../../shared/icons';
import { useFormContext } from 'react-hook-form';
import { LayoutColumn } from '../../../../../shared/layout';
import { LayoutContext } from '../../../../../../contexts/layoutContext';
import { theme } from '../../../../../../styles/theme';
import { isEmpty, convertCostCleanly } from '../../../../../../utils/helper';
import { IBrandItemProps } from './brandItem.types';

const BrandItem: FC<IBrandItemProps> = ({
  col,
  selectedSupplierBrands,
  setIngredientData,
}) => {
  const [toggle, setToggle] = useState(false);
  const { register, watch } = useFormContext();
  const { appWidth, dispatch } = useContext(LayoutContext);

  const toggleChecked = watch('brand');

  const editBrand = (brandId: string) => {
    setIngredientData();
    dispatch({ type: 'SET_BRAND_USER_EVENT', payload: 'edit' });
    dispatch({ type: 'SELECT_BRAND', payload: brandId });
    dispatch({ type: 'TOP_SLIDER_PAGE', payload: 'brand' });
  };

  const getRowHeader = (selected: boolean, toggleChecked: string) => {
    if (appWidth !== 0 && appWidth < theme.mQ.mobileM) {
      return (
        <Header>
          <Span
            color={
              selected || toggleChecked === col.brand.id ? 'black' : 'faded'
            }
            className={toggle ? 'title' : ''}
          >
            {col.brand.displayName}
          </Span>
          <LayoutColumn>
            <Span
              color={
                selected || toggleChecked === col.brand.id ? 'grey' : 'faded'
              }
              className="last"
            >
              {convertCostCleanly(col.size.productCost)}
            </Span>
          </LayoutColumn>
        </Header>
      );
    } else if (appWidth !== 0 && appWidth < theme.mQ.mobileL) {
      return (
        <Header>
          <Span
            color={
              selected || toggleChecked === col.brand.id ? 'black' : 'faded'
            }
            className={toggle ? 'title' : ''}
          >
            {col.brand.displayName}
          </Span>
          <LayoutColumn>
            <Span
              color={
                selected || toggleChecked === col.brand.id ? 'grey' : 'faded'
              }
              className="last"
            >
              {convertCostCleanly(col.size.productCost)}
            </Span>
          </LayoutColumn>
        </Header>
      );
    } else {
      return (
        <Header>
          <Span
            color={
              selected || toggleChecked === col.brand.id ? 'black' : 'faded'
            }
            className={toggle ? 'title' : ''}
          >
            {col.brand.displayName}
          </Span>
          <LayoutColumn>
            {col.size && (
              <Span
                color={
                  selected || toggleChecked === col.brand.id ? 'grey' : 'faded'
                }
                className="last"
              >
                {convertCostCleanly(col.size.productCost)}
              </Span>
            )}
          </LayoutColumn>
        </Header>
      );
    }
  };

  let selected = true;
  if (!isEmpty(selectedSupplierBrands)) {
    selected = selectedSupplierBrands.includes(col.brand.id);
  }

  return (
    <LabelWrap className={selected ? 'highlight' : ''}>
      <Row>
        <Col>
          <Radio
            type="radio"
            name="brand"
            value={col.brand.id}
            ref={register}
            hidden
          />
          <Icon>
            {toggleChecked === col.brand.id ? (
              <Tick size="small" color="secondary" />
            ) : (
              <Dot size="smaller" color="default" />
            )}
          </Icon>
        </Col>
        <Col>
          <BrandRow>
            {getRowHeader(selected, toggleChecked)}
            {toggle && (
              <BrandDetails>
                {col.brand.website && (
                  <a
                    href={`//${col.brand.website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {col.brand.website}
                  </a>
                )}
                <Span>{col.brand.email}</Span>
                <Span>{col.brand.phone}</Span>
              </BrandDetails>
            )}
          </BrandRow>
        </Col>
        <Col className="icons" toggle={toggle}>
          <BrandRow>
            <Icon onClick={() => setToggle(!toggle)}>
              <Arrow
                size="smaller"
                color="grey"
                faded
                rotate={toggle ? 270 : 90}
              />
            </Icon>
            {toggle && (
              <BrandDetails onClick={() => editBrand(col.brand.id)}>
                <Icon>
                  <Edit size="small" color="grey" faded />
                </Icon>
              </BrandDetails>
            )}
          </BrandRow>
        </Col>
      </Row>
    </LabelWrap>
  );
};

export default BrandItem;
